import React from 'react';
import '../styles/Footer.css';

const AlcFooter = ({ lang, bg }) => {
	const packages = document.querySelectorAll('.package_visual');
	const indicator = document.querySelectorAll('.state_indicator');

	return lang === 'en' ? (
		<div className={bg === 'dark' ? 'alcFooterDark' : 'alcFooterWhite'}>
			<div id="footer2020" className={bg === 'dark' ? 'payment dark' : 'payment'}>
				<div className="f-line" />
				<div className="footer-inner">
					<div className="footer-info">
						<div className="info-top">
							<h2>
								<a href="https://www.chosun.com/english/">
									<img
										src={`//image.chosun.com/gnb/assets/images/${bg === 'dark' ? 'chosunG.png' : 'chosunB.png'}`}
									/>
								</a>
							</h2>
							<ul className="payinfo">
								<li>
									Contact Us (ALC Secretariat): +82-2-724-6201-2, 6224-6227 / alc_reg@chosun.com
									&nbsp;&nbsp;
									{packages.length > 0 ? 'Business Number. 104-81-24695' : ''}
								</li>
								<li>Company name: The Chosunilbo</li>
								<li> President: Jun-Ho Hong</li>
								<li>Contact: +82-2-724-5114</li>
								<li>Address: 30, Sejong-daero 21-gil, Jung-gu</li>
							</ul>
							<ul className="company">
								<li className="copy">Copyright Chosunilbo All rights reserved.</li>
							</ul>
						</div>
						<div className="info-bottom">
							<div className="f-line" />
							<ul className={bg === 'dark' ? 'policy dark' : 'policy'}>
								<li>
									<a
										href="https://www.chosun.com/subscribe/privacy/english/"
										target="_blank"
										title="새창열림"
										rel="noreferrer"
									>
										<strong>Privacy Policy</strong>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	) : (
		<div className={bg === 'dark' ? 'alcFooterDark' : 'alcFooterWhite'}>
			<div id="footer2020" className={bg === 'dark' ? 'payment dark' : 'payment'}>
				<div className="f-line" />
				<div className="footer-inner">
					<div className="footer-info">
						<div className="info-top">
							<h2>
								<a href="https://www.chosun.com/">
									<img
										src={`//image.chosun.com/gnb/assets/images/${bg === 'dark' ? 'chosunG.png' : 'chosunB.png'}`}
									/>
								</a>
							</h2>
							<ul className="payinfo">
								<li>행사 문의(ALC사무국): 02-724-6201~2, 6224~6227 / alc_reg@chosun.com</li>
								<li>상호: 조선일보사</li>
								<li>발행인: 홍준호</li>
								<li>편집인: 양상훈</li>
								<li>연락처: 02-724-5114</li>
								<li>주소: 서울특별시 중구 세종대로21길 30</li>
							</ul>
							<ul className="company">
								<li className="copy">Copyright 조선일보 All rights reserved.</li>
							</ul>
						</div>
						<div className="info-bottom">
							<div className="f-line" />
							<ul className={bg === 'dark' ? 'policy dark' : 'policy'}>
								<li>
									<a
										href="https://members.chosun.com/cms_user/privacy/web/index.jsp"
										target="_blank"
										title="새창열림"
										rel="noreferrer"
									>
										<strong>개인정보처리방침</strong>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AlcFooter;
